const alderReveal = () => {
  const items = document.querySelectorAll('.ar-reveal:not([data-ar-ready])');

  if (!items.length) return;

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach((item) => {
      item.dataset.arReady = 'true';
      item.classList.add('is-visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  items.forEach((item) => {
    item.dataset.arReady = 'true';
    observer.observe(item);
  });
};

const alderReviewKeyboard = () => {
  document.querySelectorAll('.ar-reviews__track:not([data-ar-keyboard])').forEach((track) => {
    track.dataset.arKeyboard = 'true';
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      track.scrollBy({ left: track.clientWidth * 0.75 * direction, behavior: 'smooth' });
    });
  });
};

const alderFeaturedCollectionControls = () => {
  document
    .querySelectorAll(
      '.shopify-section--featured-collection button[aria-controls][is="prev-button"], ' +
        '.shopify-section--featured-collection button[aria-controls][is="next-button"]'
    )
    .forEach((button) => {
      if (button.dataset.arCarouselControl === 'true') return;

      const carousel = document.getElementById(button.getAttribute('aria-controls'));
      if (!carousel || !carousel.querySelector('.product-card')) return;

      button.dataset.arCarouselControl = 'true';

      const updateControls = () => {
        const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
        const previousButton = document.querySelector(
          `button[is="prev-button"][aria-controls="${carousel.id}"]`
        );
        const nextButton = document.querySelector(
          `button[is="next-button"][aria-controls="${carousel.id}"]`
        );

        if (previousButton) previousButton.disabled = carousel.scrollLeft <= 2;
        if (nextButton) nextButton.disabled = carousel.scrollLeft >= maxScroll - 2;
      };

      button.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();

          const cards = Array.from(carousel.querySelectorAll('.product-card')).filter(
            (card) => card.offsetParent !== null
          );
          const cardStep =
            cards.length > 1
              ? Math.abs(cards[1].offsetLeft - cards[0].offsetLeft)
              : carousel.clientWidth * 0.8;
          const direction = button.getAttribute('is') === 'next-button' ? 1 : -1;
          const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);

          carousel.scrollTo({
            left: Math.min(
              maxScroll,
              Math.max(0, carousel.scrollLeft + cardStep * direction)
            ),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'auto'
              : 'smooth'
          });
        },
        true
      );

      if (carousel.dataset.arCarouselState !== 'true') {
        carousel.dataset.arCarouselState = 'true';
        carousel.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls, { passive: true });
      }

      updateControls();
    });
};

const alderInit = () => {
  alderReveal();
  alderReviewKeyboard();
  alderFeaturedCollectionControls();
};

document.addEventListener('DOMContentLoaded', alderInit);
document.addEventListener('shopify:section:load', alderInit);

